module.exports = __webpack_public_path__ + "static/img/b1-1-2.7ab4c52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/b1-1-2.png
// module id = yWq9
// module chunks = 1